import { createApp } from 'vue';
import FreePrashnaView from '../../free/FreePrashnaView.vue'

const appElements = document.querySelectorAll('.vue-basic-prashna-app-view')

Array.from(appElements).forEach(element => {
  createApp(FreePrashnaView).mount(element);
});